var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.004 16C11.8669 16 11.7404 15.9738 11.6245 15.9214C11.5086 15.869 11.3979 15.7904 11.2925 15.6857L7.26877 11.5639C7.08959 11.391 7 11.1762 7 10.9194C7 10.7518 7.04216 10.5972 7.12648 10.4558C7.20553 10.3143 7.31621 10.2017 7.4585 10.1179C7.59552 10.0393 7.74835 10 7.917 10C8.16996 10 8.39394 10.0943 8.58893 10.2829L12.004 13.7996L15.419 10.2829C15.614 10.0943 15.8353 10 16.083 10C16.2569 10 16.4124 10.0393 16.5494 10.1179C16.6864 10.2017 16.7945 10.3143 16.8735 10.4558C16.9578 10.5972 17 10.7518 17 10.9195C17 11.1762 16.913 11.391 16.7391 11.5639L12.7154 15.6857C12.61 15.7904 12.4993 15.869 12.3834 15.9214C12.2675 15.9738 12.141 16 12.004 16Z",
    fill: "#03122E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/ChevronDown.1939e9f709c53c1c353eaa1ae4c76877.svg";
export { ForwardRef as ReactComponent };